import React from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';

import Routes from './routes';
import store from './store';
import * as Helpers from './helpers';
import './assets/styles/main.css';

function App() {
  return (
    <Provider store={store}>
      <SnackbarProvider
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
        ref={Helpers.notification.reference}
        action={key => <div onClick={() => Helpers.notification.close(key)}>DISMISS</div>}
      >
        <Routes />
      </SnackbarProvider>
    </Provider>
  );
}

export default App;
